module.exports = "<div id=\"gmap\"></div>\n<div \tid=\"current-location\"\n\t\t\t[ngClass]=\"currentLocationClass\"\n\t\t\t(click)=\"currentLocationClick()\">\n\t<img src=\"assets/electraAssets/currentLocation.svg\" />\n</div>\n<div \tid=\"popup\"\n\t\t\t[ngClass]=\"popupClass\">\n\t<div id=\"popup-content\"></div>\n\t<div id=\"popup-close\" (click)=\"popupClose()\">\n    <img src=\"assets/electraAssets/clearGrey.svg\" />\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/map/map.component.html
// module id = 428
// module chunks = 1